export default __webpack_public_path__ + "static/media/logos.01c1cae8.png";